import { History } from 'history'

export interface StockAdjustmentInBatchState {
  uploadFilePage: {
    adjustment?: Adjustment
    invalidStructure?: InvalidStructureDetails
  }
  pendingAdjustment: PendingAdjustment[]
  totalItems: number
  adjustment?: Adjustment
  adjustmentDetails: AdjustmentDetails
  filters: AdjustmentsFilters
}

export interface Adjustment {
  id: number
  createdAt: Date
  idUser: number
  status: AdjustmentStatus
}

export enum AdjustmentStatus {
  INVALID = 'INVALID'
}

export interface InvalidStructureDetails {
  missingColumns: string[]
}

export enum ErrorTypes {
  INVALID_STRUCTURE = 'INVALID_STRUCTURE',
}

export interface PendingAdjustment {
  id: number
  createdAt: Date
  totalAdjustments: number
  user: string
}

export interface AdjustmentDetails {
  user: string
  createdAt: Date | string
  totalAdjustments: number
  items: AdjustmentDetailItem[]
}

export interface AdjustmentDetailItem {
  productCode: string
  address: string
  quantity: number
  validatedDate: Date | string
  destination?: string
  measureUnit: string
}

export enum DecisionEnum {
  BOTH = 'BOTH',
  MAIN_STOCK_ONLY = 'MAIN_STOCK_ONLY',
  WSS_STOCK_ONLY = 'WSS_STOCK_ONLY'
}

export interface ActionPendingPayloadConfirm{
  adjustmentId: number,
  history: History,
  decision: DecisionEnum
}

export interface ActionPendingPayloadCancel{
  adjustmentId: number,
  history: History
}

export interface TableRowItems {
  user: string;
  createdAt: string;
  totalAdjustments: string;
  id: number;
}

export interface AdjustmentsFilters {
  startDate?: Date
  endDate?: Date
  user?: string
}
